import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';

export default function TermsOfService() {
  usePageTitle({
    title: 'Terms of Service',
    description: 'Read our terms of service for using the AI avatar generation platform.'
  });
  return (
    <>
      <div className="py-4 py-lg-4 py-md-5"></div>
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-12 col-md-10 offset-md-1">
            <h1 className="display-1 text-dark">
              Terms of Service
            </h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8 offset-md-1 col-lg-7 offset-lg-1">
            <div className="py-4">
              <h2 className="fs-3 fw-light mb-4">
                Last updated: {new Date().toLocaleDateString()}
              </h2>
              
              <div className="mb-5">
                <h3 className="h4 mb-3">1. Acceptance of Terms</h3>
                <p className="c-c3">
                  By accessing and using ITORA's services, you accept and agree to be bound by the terms 
                  and provision of this agreement. If you do not agree to abide by the above, please do 
                  not use this service.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">2. Use License</h3>
                <p className="c-c3">
                  Permission is granted to temporarily use our services for personal, non-commercial 
                  transitory viewing only. This is the grant of a license, not a transfer of title, 
                  and under this license you may not modify or copy the materials.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">3. Service Description</h3>
                <p className="c-c3">
                  ITORA provides AI-powered avatar generation services for fashion and product photography. 
                  Our services include image processing, avatar creation, and related digital content 
                  generation tools.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">4. User Responsibilities</h3>
                <p className="c-c3">
                  You are responsible for providing accurate information, maintaining the security of 
                  your account, and ensuring that your use of our services complies with applicable 
                  laws and regulations.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">5. Intellectual Property</h3>
                <p className="c-c3">
                  The content and materials available through our services are protected by copyright, 
                  trademark, and other intellectual property laws. You retain ownership of content you 
                  create using our services.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">6. Limitation of Liability</h3>
                <p className="c-c3">
                  In no event shall ITORA be liable for any damages arising out of the use or inability 
                  to use our services, even if ITORA has been notified orally or in writing of the 
                  possibility of such damage.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">7. Contact Information</h3>
                <p className="c-c3">
                  If you have any questions about these Terms of Service, please contact us at{' '}
                  <a href="mailto:hello@itora.io" className="c-c00">hello@itora.io</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 